export enum ESpecTypes {
  RATING = 'rating',
  ACTIONS = 'actions',
  DURATION = 'duration',
  LIST = 'list',
}
